// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress__4IaUD","title":"title__qjXDQ","text":"text__0HGQ4","percentage":"percentage__V-K5Q","bar":"bar__RY9zB","level":"level__COLfs","fetching":"fetching__1YUuJ"};